export default __webpack_public_path__ + "static/media/Regulator high pressure.7d5c4c58.jpeg";